























import {
	defineComponent,
} from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { RefreshPageStore } from '@front-app/store/singletons/RefreshPage';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import SimpleCard from './cards/SimpleCard.vue';

export default defineComponent({
	components: {
		SimpleCard,
		CtaButton,
	},
	setup() {
		const {
			doesUpdateExist,
			refreshApp,
		} = RefreshPageStore;
		return {
			ButtonPalettes,
			doesUpdateExist,
			refreshApp,
		};
	},
});
